import HiringSourceSelect from './HiringSourceSelect';

export default HiringSourceSelect;
